export class Assets {
    netWorth: string;
    liquidNetWorth: string;
    netInCome: string;
}
